<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    const dispatch = createEventDispatcher()
    import Fa from 'svelte-fa'
    import { faAngleLeft, faEdit, faPlusCircle, faSave, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import Zact from '../../_common/z/zact.svelte'
    import { EntryTypeEnum } from '../../../modules/financialApi/entries/entry.enum'
    import { Classification } from '../../../modules/financialApi/classifications/classification'
    import type { CreateClassificationDto } from '../../../modules/financialApi/classifications/dto/create-classification.dto'
    import type { UpdateClassificationDto } from '../../../modules/financialApi/classifications/dto/update-classification.dto'
    import AccountSelect from '../../financial/accounts/account-select.svelte'
    import CategorySelect from '../../financial/categories/category-select.svelte'
    // ##############################################################################################################

    export let form: boolean = false
    export let classificationId: string = null
    export let sugestion: { accountId: string; creditDebit: EntryTypeEnum; description: string; categoryId: string } = null
    let entity: Classification = new Classification()

    let accrual: string = ''
    let accrualPeriod: 'monthly' | 'yearly' = 'monthly'

    async function editEntity(id: string) {
        try {
            show = true
            step = 2
            entity = new Classification()
            entity = await window.api.financials.classifications.getOne(id)
            entity.person = await window.api.events.persons.getOne(entity.personId)
            entity.category = await window.api.financials.categories.getOne(entity.categoryId)
            entity.account = await window.api.financials.accounts.getOne(entity.accountId)
            // se foi informada alguma competência
            if (entity.accrualType) {
                if (entity.accrualMonth === null) {
                    accrualPeriod = 'yearly'
                } else {
                    accrualPeriod = 'monthly'
                }
                if (entity.accrualType === 'absolute') {
                    if (entity.accrualMonth === null) {
                        accrual = `${entity.accrualYear}-${String(entity.accrualMonth).padStart(2, '0')}`
                    } else {
                        accrual = entity.accrualYear.toString()
                    }
                } else {
                    accrual = ''
                }
            }
            console.log('classification', entity)
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function newEntity() {
        entity = new Classification()
        if (sugestion) {
            entity.creditDebit = sugestion.creditDebit
            entity.categoryId = sugestion.categoryId
            entity.accountId = sugestion.accountId
            entity.match = sugestion.description
            entity.category = await window.api.financials.categories.getOne(entity.categoryId)
            entity.account = await window.api.financials.accounts.getOne(entity.accountId)
        }
        step = 2
    }

    function validateDto(dto) {
        if (!dto.match) {
            window.error('Informe o termo a ser encontrado na descrição.')
            return false
        }
        if (dto.match.length < 3) {
            window.error('O termo a ser encontrado na descrição deve possuir ao menos 3 caracteres.')
            return false
        }
        if (!dto.accountId) {
            window.error('Informe a conta.')
            return false
        }
        if (!dto.categoryId) {
            window.error('Informe a categoria a ser atribuída.')
            return false
        }
        if (!dto.personId) {
            //if (!confirm('É recomendado informar o pagador/recebedor deste lançamento.\nDeseja mesmo continuar?')) return false
        }
        return true
    }

    async function createEntity() {
        try {
            show = true
            const dto: CreateClassificationDto = {
                accountId: entity.account.accountId,
                categoryId: entity.category.categoryId,
                match: entity.match,
                personId: entity.person?.personId,
                creditDebit: entity.creditDebit,
                accrualMonth: entity.accrualMonth,
                accrualYear: entity.accrualYear,
                accrualType: entity.accrualType,
            }
            if (!validateDto(dto)) return
            entity = await window.api.financials.classifications.create(dto)
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function sendClose() {
        dispatch('close')
    }

    async function updateEntity() {
        try {
            show = true
            const dto: UpdateClassificationDto = {
                accountId: entity.account.accountId,
                categoryId: entity.category.categoryId,
                match: entity.match,
                personId: entity.person?.personId,
                creditDebit: entity.creditDebit,
                accrualMonth: entity.accrualMonth,
                accrualYear: entity.accrualYear,
                accrualType: entity.accrualType,
            }
            if (!validateDto(dto)) return
            await window.api.financials.classifications.update(entity.classificationId, dto)
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function saveEntity() {
        if (window.configs.financialShowAccrual) {
            if (entity.accrualType === 'absolute') {
                console.log('accrual', accrual)
                if (accrualPeriod === 'monthly') {
                    accrual = accrual.toString()
                    entity.accrualYear = parseInt(accrual.split('-')[0])
                    entity.accrualMonth = parseInt(accrual.split('-')[1])
                } else {
                    entity.accrualYear = parseInt(accrual)
                    entity.accrualMonth = null
                }
            }
        }
        if (entity.classificationId) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    async function loadEntities() {
        try {
            show = true
            step = 1
            entities = await window.api.financials.classifications.getAll()
            entities = await window.api.utils.utils.assignPersonsFromObject(entities)
            entities = await window.api.utils.utils.assignAccountFromObject(entities)
            entities = await window.api.utils.utils.assignFinancialCategoryFromObject(entities)
            console.log('entities', entities)
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.fontSize = '15px'
        grid.title = 'Classificações automáticas'
        grid.subtitle = 'Classifique automaticamente seus lançamentos financeiros e economize muito tempo.'
        grid.cols.push(new GridCol({ content: 'Data de criação', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Conta', type: GridColTypeEnum.string }))
        grid.cols.push(new GridCol({ content: 'Conteúdo procurado' }))
        grid.cols.push(new GridCol({ content: 'Categoria a atribuir' }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            const btnEdit = new GridButton({
                callback: () => editEntity(item.classificationId),
                icon: faEdit,
                label: 'Editar',
            })
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: item.account?.label })
            line.slots.push({ content: item.match })
            line.slots.push({ content: item.category?.label })
            line.slots.push({ content: [btnEdit] })
            grid.lines.push(line)
        }
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await window.api.financials.classifications.remove(entity.classificationId)
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function showEntities() {
        step = 1
    }

    let show = false
    let step = 1
    let entities: Classification[] = []

    onMount(async () => {
        await loadEntities()
        if (form) {
            if (classificationId) {
                await editEntity(classificationId)
            } else {
                await newEntity()
            }
        }
    })

    const currentYear = new Date().getFullYear()
    const months = window.api.utils.utils.getAllMonths()
</script>

<div>
    {#if step === 1}
        <Zact>
            <div class="spacer" />
            <button class="btn btn-primary" on:click={newEntity}><Fa icon={faPlusCircle} /> Novo</button>
        </Zact>
        <Zgrid class="m-3" {grid} />
    {/if}

    {#if step === 2}
        <Zact>
            {#if !form}
                <button class="btn btn-secondary" on:click={showEntities}><Fa icon={faAngleLeft} /> Voltar</button>
            {/if}
            <div class="spacer" />
            {#if !!entity.classificationId}
                <button class="btn btn-warning me-2" on:click={removeEntity}><Fa icon={faTrashAlt} /> Excluir</button>
            {/if}
            <button class="btn btn-primary" on:click={saveEntity}><Fa icon={faSave} /> Salvar</button>
        </Zact>

        <Zframe title="Configurações da classificação" class="m-3 mb-0">
            <div class="grid-form">
                <div class="row">
                    <div class="col-5">
                        <AccountSelect label="Conta" bind:account={entity.account} />
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="input-group">
                            <label for="" class="input-group-text">Caso o registro seja</label>
                            <select class="form-select" bind:value={entity.creditDebit}>
                                <option value=""></option>
                                <option value="credit">Crédito</option>
                                <option value="debit">Débito</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="input-group">
                            <label for="" class="input-group-text">E parte da descrição possua este texto</label>
                            <input type="text" bind:value={entity.match} class="form-control" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        {#if entity.creditDebit === EntryTypeEnum.credit}
                            <CategorySelect label="Atribuir esta categoria" creditDebit={EntryTypeEnum.credit} bind:category={entity.category}></CategorySelect>
                        {:else}
                            <CategorySelect label="Atribuir esta categoria" creditDebit={EntryTypeEnum.debit} bind:category={entity.category}></CategorySelect>
                        {/if}
                    </div>
                </div>
                {#if window.configs.financialShowAccrual}
                    <div class="row">
                        <div class="col-md-4">
                            <div class="input-group">
                                <label for="" class="input-group-text">Atribuir competência</label>
                                <select bind:value={entity.accrualType} class="form-select">
                                    <option value="relative">Relativa</option>
                                    <option value="absolute">Absoluta</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="input-group">
                                <label for="" class="input-group-text">Tipo</label>
                                <select bind:value={accrualPeriod} class="form-select">
                                    <option value="monthly">Mensal</option>
                                    <option value="yearly">Anual</option>
                                </select>
                            </div>
                        </div>

                        {#if entity.accrualType === 'relative'}
                            {#if accrualPeriod === 'monthly'}
                                <div class="col">
                                    <div class="input-group">
                                        <label for="" class="input-group-text">Mês</label>
                                        <select bind:value={entity.accrualMonth} class="form-select">
                                            <option value={0}>do pagamento</option>
                                            <option value={-1}>1 anterior ao pagamento</option>
                                            {#each new Array(119) as _, i}
                                                <option value={(i + 2) * -1}>{i + 2} anteriores ao pagamento</option>
                                            {/each}
                                        </select>
                                    </div>
                                </div>
                            {:else}
                                <div class="col">
                                    <div class="input-group">
                                        <label for="" class="input-group-text">Ano</label>
                                        <select bind:value={entity.accrualYear} class="form-select">
                                            <option value={0}>do pagamento</option>
                                            <option value={-1}>1 anterior ao pagamento</option>
                                            {#each new Array(11) as _, i}
                                                <option value={(i + 2) * -1}>{i + 2} anteriores ao pagamento</option>
                                            {/each}
                                        </select>
                                    </div>
                                </div>
                            {/if}
                        {:else}
                            <div class="col">
                                {#if accrualPeriod === 'monthly'}
                                    <div class="input-group">
                                        <label for="" class="input-group-text">Mês de competência</label>
                                        <input type="month" bind:value={accrual} class="form-control" />
                                    </div>
                                {:else}
                                    <div class="input-group">
                                        <label for="" class="input-group-text">Ano de competência</label>
                                        <input type="number" bind:value={accrual} class="form-control" />
                                    </div>
                                {/if}
                            </div>
                        {/if}
                    </div>
                {/if}
                
            </div>
        </Zframe>
    {/if}

    <div class="config-box text-muted mx-3 mt-3">
        A classificação automática atribui uma categoria a um registro financeiro de seu extrato bancário durante a importação.<br />
        Utilize este recurso para categorizar contas repetitivas que possuem sempre a mesma categoria.<br />
        Caso o campo de descrição possua o texto informado e o valor for do tipo informado (crédito ou débito) a categoria é atribuída automaticamente.<br />
        Caso mais de uma regra seja aplicável a um lançamento, a regra criada primeiro será aplicada.
    </div>
    <div class="config-box text-muted mx-3 mt-3">
        <b>Dica muito útil:</b> No campo da descrição você não precisa informar todo o texto da descrição. Basta informar uma parte.<br />
        Isso é útil quando as descrições do lançamento em seu extrato bancário possuem partes que mudam a cada lançamento.<br />
        Nestes casos basta informar a parte da descrição que não muda.
    </div>
</div>
